import React from 'react';
import { useDevice } from '@bonnet/next/device';
import PropTypes from 'prop-types';
import { PageSection } from 'reaxl';
import { breakpoints } from 'axl-config';
import { callToActionAnalytics } from '@/analytics';
import BrowseByStyle from '@/component/BrowseByStyle';

function ImageTitlePlaceholderStyle({ imageTitlePlaceholderClassName }) {
    return (
        <style type="text/css">
            {`
            .${imageTitlePlaceholderClassName} {
                min-height: 126px;
            }

            @media screen and (max-width: ${breakpoints.max.md}px) {
                .${imageTitlePlaceholderClassName} {
                    min-height: 110px;
                }
            }

            @media screen and (max-width: ${breakpoints.max.sm}px) {
                .${imageTitlePlaceholderClassName} {
                    min-height: 96px;
                }
            }

            @media screen and (max-width: ${breakpoints.max.xs}px) {
                .${imageTitlePlaceholderClassName} {
                    min-height: 92px;
                }
            }
        `}
        </style>
    );
}

const BrowseByStylesContainer = React.memo(({ pageValue = '', styleCodes, zipCode, dealerId }) => {
    const bodyStyles = [];
    const vehicleStyles = [];

    const device = useDevice();
    const { mediaType } = device;
    const imageTitlePlaceholderClassName = 'image-title-placeholder';
    const imageSizePerViewport = {
        lg: {
            width: 224,
            height: 120,
        },
        md: {
            width: 190,
            height: 102,
        },
        sm: {
            width: 168,
            height: 90,
        },
        xs: {
            width: 160,
            height: 86,
        },
    };
    const imageWidth = imageSizePerViewport[mediaType].width;
    const imageHeight = imageSizePerViewport[mediaType].height;

    const certifiedHeadingCheck = pageValue === 'certified' ? 'Shop Certified Vehicles by Style' : 'Shop Used Vehicles by Style';
    const heading = pageValue === 'new' ? 'Shop New Vehicles by Style' : certifiedHeadingCheck;

    const handleStyleClickCallback = (event, item) => {
        const label = item.displayName || 'BrowesByStyle';
        callToActionAnalytics.fireBrowseByStyle(event, { co_txt_url: label, suffix: '_btm', styleSelection: true, zip: zipCode, dealerId, hasListingType: false });
    };

    Object.keys(styleCodes).forEach((key) => {
        const {
            src,
            type,
            link,
            displayName,
        } = styleCodes[key];

        let srpLink = `/cars-for-sale${link}`.toLowerCase();
        const certifiedLabelCheck = pageValue === 'certified' ? `Certified ${displayName}s` : `Used ${displayName}s`;
        const label = pageValue === 'new' ? `New ${displayName}` : certifiedLabelCheck;

        if (pageValue === 'new' || pageValue === 'certified') {
            srpLink = `/cars-for-sale/${pageValue}-cars${link}`.toLowerCase();
        }

        const style = {
            src,
            href: srpLink,
            label,
            alt: `Research ${displayName} Information, Reviews, and Inventory near you`,
        };

        if (type === 'bodyStyle') {
            bodyStyles.push(style);
        } else {
            vehicleStyles.push(style);
        }
    });
    return (
        <>
            <ImageTitlePlaceholderStyle imageTitlePlaceholderClassName={imageTitlePlaceholderClassName} />
            <PageSection
                id="browseByStylesModuleSection"
                uiContext="section-2"
                headingClassName="text-primary"
                headingComponentClass="h2"
                heading={heading}
                alignment="left"
                offset={1}
            >
                <BrowseByStyle
                    bodyStyles={bodyStyles}
                    vehicleStyles={vehicleStyles}
                    vehicleStylesAlign="center"
                    onClick={handleStyleClickCallback}
                    fixedImageLabelWidth={imageWidth}
                    fixedImageLabelHeight={imageHeight}
                    imageTitlePlaceholderClassName={imageTitlePlaceholderClassName}
                />
            </PageSection>
        </>
    );
});

BrowseByStylesContainer.propTypes = {
    styleCodes: PropTypes.object,
    zipCode: PropTypes.string,
    dealerId: PropTypes.string,
};

export default BrowseByStylesContainer;
